<template>
    <section id="checkout" v-if="initialized">
        <div class="progressSteps">
            <div class="title">Bestellvorgang</div>
            <div class="step selected">1</div>
            <div class="separator"><hr></div>
            <div class="step">2</div>
            <div class="separator"><hr></div>
            <div class="step">3</div>
        </div>
        <form :action="processUrl" method="post" ref="form" @submit.prevent="validate">
            <input type="hidden" name="_token" :value="token" />

            <shipping-address :user="user" ref="shipping"></shipping-address>

            <div class="row">
                <div class="col-sm-12">
                    <button type="submit" class="btn btn-primary btn-sm pull-right">Weiter</button> 
                </div>
            </div>

        </form>
    </section>
</template>

<script>
export default {

  data() {
    return {
        initialized: false,
        cartEmpty: true,
        user: null,
    }
  },
  
  computed: {

    processUrl() {
        return App.url + '/checkout/process';
    },

    token() {
        return App.token;
    }

  },

  methods: {

        fetchUser() {
            new Form().get('/api/me')
            .then(user => {
                this.user = user;
                this.user.name = this.user.firstName+" "+this.user.lastName;
                this.initialized = true;
                App.event.fire('user.logged-in', user);
                App.event.fire('billing.changed', user.billing);
            }).catch(error => {
                this.initialized = true;
                App.event.fire('user.logged-out', error);
            });
        },

        validate() {
            if (this.$refs.shipping.validate()) {
                this.$refs.form.submit();
            }
        }

    },

    created() {
        this.fetchUser();
    }

}
</script>
